<div (click)="checkAlerts()">
  <ng-content></ng-content>
</div>
